'use strict';
// Import Fancybox
import { Fancybox } from '@fancyapps/ui';
window.Fancybox = Fancybox;
// Import SweetAlert2
import Swal from 'sweetalert2/dist/sweetalert2.js';
// Import Perfect Scrollbar
//import './perfect-scrollbar/perfect-scrollbar.js';
//import "./perfect-scrollbar/perfect-scrollbar.css";
// Import Bootstrap modal
import { Modal } from 'bootstrap';
// Import Quill WYSIWYG editor
import Quill from 'quill';
// Import fuzzysort search
import fuzzysort from 'fuzzysort';
// Import main SCSS to compile
//import "./scss/moretto-portal.scss";
import $ from 'jquery';
window.$ = $;
// Deplare main container object
window.Portal = {};
// Create elements container object
Portal.el = {};
// Create data object
Portal.data = {};
// Create config object
Portal.config = {};
// Set config options
Portal.config.debug = true;

// DOMContentLoaded event
window.addEventListener('DOMContentLoaded', event => {
  // Remove prealoder class to fix animation after DOM loading
  document.getElementsByTagName('body')[0].classList.remove('mor-preloader');

  // APP DOCUMENTATION
  Portal.el.mainMenu = document.getElementById('main_menu');
  Portal.el.appDoc = document.getElementById('app_doc');
  Portal.el.appDocMenuWrapper = document.getElementById('app_doc_menu_wrapper');
  Portal.el.appDocMenu = document.getElementById('app_doc_menu');
  Portal.el.appDocSearchInput = document.getElementById('app_doc_search_input');
  Portal.el.appDocList = document.getElementById('app_doc_list');
  Portal.el.appDocListEmpty = document.getElementById('app_doc_list_empty');
  Portal.el.appDocListEmptyReset = document.getElementById('app_doc_list_empty_reset');
  Portal.el.appDocFilters = document.getElementById('app_doc_filters');
  Portal.el.appDocBtnFilterItemsUpdated = document.getElementById('app_doc_btn_filter_items_updated');
  Portal.el.appDocBtnDownload = document.getElementById('app_doc_btn_download_sel');
  // DASHBOARD
  Portal.el.dashboard = document.getElementById('dashboard');
  // COMMON WIDGET
  Portal.el.pdfViewer = document.getElementById('pdf_viewer');
  // DATA
  Portal.data.appDocListItems = [];
  Portal.data.searchResults = [];
  // CONFIG
  Portal.config.assetsPath = 'assets/';
  Portal.config.appDocFiltersCount = 0;
  Portal.config.appDocFiltersActiveCount = 0;
  Portal.config.appDocVisibleItemsCount = 0;
  Portal.config.downloadSelection = 0;
  Portal.config.fancyboxVideoOptions = {
    mainClass: 'mor-fancybox--video',
    protected: true,
    on: {
      '*': (fancybox, eventName) => {
        switch (eventName) {
          case 'close':
            if (document.activeElement) {
              document.activeElement.blur();
            }
        }
      }
    }
  };

  // Activate Fancybox for video
  Fancybox.bind('[data-video]', Portal.config.fancyboxVideoOptions);

  // Set pdfViewer download button event listener
  if (Portal.el.pdfViewer) {
    // Download pdf when clicking download button in the pdf viewer modal
    Portal.el.pdfViewer.getElementsByClassName('btn-viewer-download')[0].addEventListener('click', event => {
      let src = event.target.dataset.src;
      if (src) open(src);
    });
    // Expand pdf viewer width
    Portal.el.pdfViewer.getElementsByClassName('btn-viewer-expand')[0].addEventListener('click', event => {
        event.preventDefault();
        // Get button, the button text element (span) if exists or button itself if span is not present
        let btn = event.currentTarget,
            btnText = btn.getElementsByTagName('span')[0] ?? btn;
        if (!Portal.el.pdfViewer.classList.contains('expanded')) {
          // Update button text and add expanded class
          btnText.innerText = btn.dataset.textShrink ?? 'Hide';
          Portal.el.pdfViewer.classList.add('expanded');
        } else {
          // Update button text and remove expanded class
          btnText.innerText = btn.dataset.textExpand ?? 'Expand';
          Portal.el.pdfViewer.classList.remove('expanded');
        }
        // Unfocus button
        if (btn.nodeName === 'BUTTON') { btn.blur() };
    });
  }

  // Set sidebar link to open Fancybox
  if (Portal.el.mainMenu) {
    // Activate perfect Scrollbar for sidebar nav
    initPerfectScrollbar(Portal.el.mainMenu);
    // Presentations
    const mainMenuPresentations = Portal.el.mainMenu.querySelectorAll("[data-type='presentation']");
    for (const presentation of mainMenuPresentations) {
      presentation.addEventListener('click', event => {
        event.preventDefault();
        openPresentation(event.currentTarget);
      });
    }
    // Company Profile
    const mainMenuPdfs = Portal.el.mainMenu.querySelectorAll("[data-type='pdf']");
    for (const pdf of mainMenuPdfs) {
      pdf.addEventListener('click', event => {
        event.preventDefault();
        openPdfModal(event.currentTarget);
      });
    }
  }

  // PORTAL APP DOCUMENTATION
  if (Portal.el.appDoc) {
    // Check for helpers object
    if (typeof Helpers !== 'undefined') {
      Helpers.initSidebarToggle();
    }
    //else console.log('Warning: Helpers.js is not available. appDoc sidebar will not function on mobile.');

    // Activate Perfect Scrollbar
    if (Portal.el.appDocMenuWrapper) {
      initPerfectScrollbar(Portal.el.appDocMenuWrapper);
    }
    if (Portal.el.appDocList) {
      initPerfectScrollbar(Portal.el.appDocList);
    }
    if (Portal.el.appDocFilters) {
      initPerfectScrollbar(Portal.el.appDocFilters);
    }

    // Get all list elements
    Portal.el.appDocListItems = Portal.el.appDocList.getElementsByClassName('app-doc__item');

    // Check for menu existence in the dom
    if (Portal.el.appDocMenu) {
      // Set animation duration to each menu item based on the number of its children
      let allWrappers = Portal.el.appDocMenu.getElementsByClassName('wrapper');
      let animationDuration = 0;
      for (const wrapper of allWrappers) {
        let wrapperItems = wrapper.getElementsByTagName('li');
        if (wrapperItems.length > 0) {
          animationDuration = 250 + 25 * wrapperItems.length;
          //wrapper.style.transition = `grid-template-rows ${animationDuration}ms ease, border ${animationDuration}ms ease`
          wrapper.getElementsByClassName('content')[0].style.transition = `height ${animationDuration}ms ease`;
        }
      }

      // appDocMenu item click actions
      Portal.el.appDocMenu.addEventListener(
        'click',
        event => {
          // Check for item summary
          let itemSummary = event.target.closest('summary');
          if (itemSummary) {
            let item = itemSummary.closest('details');
            let itemIcon = itemSummary.getElementsByClassName('fa')[0];

            // If clicked element is a closed folder, filter list by the current item tag and set open folder icon class (fa-folder-open), 
            // otherwise reset list filter and set closed folder icon class (fa-folder)
            if (!item.hasAttribute('open')) {
              itemIcon.classList.remove('fa-folder');
              itemIcon.classList.add('fa-folder-open');
              filterList('reset');
              filterList('.tag--' + itemSummary.dataset.tag);
            } else {
              itemIcon.classList.remove('fa-folder-open');
              itemIcon.classList.add('fa-folder');
              filterList('reset');
            }

            // Remove active class from siblings (fa-folder-open) and restore to default (fa-folder)
            let siblingsDetails = getSiblingsTag(item, 'details');
            for (const siblingDetail of siblingsDetails) {
              let siblingDetailIcon = siblingDetail.getElementsByClassName('fa')[0];
              siblingDetailIcon.classList.remove('fa-folder-open');
              siblingDetailIcon.classList.add('fa-folder');
            }

            // Find all subNav Link and remove active class
            let subNavLinks = Portal.el.appDocMenu.getElementsByTagName('a');
            //console.log(subNavLinks);
            if (subNavLinks.length > 0) {
              for (const link of subNavLinks) {
                link.classList.remove('active');
              }
            }
          }

          // Get clicked anchor
          let subNavLink = event.target.closest('a');
          if (subNavLink) {
            event.preventDefault();
            //console.log('subNav link a', subNavLink);
            let subNav = subNavLink.closest('ul');
            subNavLink.classList.contains('active')
              ? subNavLink.classList.toggle('active', false)
              : subNavLink.classList.toggle('active', true);
            //console.log('subNav', subNav);

            let siblings = subNav.querySelectorAll('li a');
            //console.log(siblings);
            if (siblings.length > 0) {
              for (const sibling of siblings) {
                sibling === subNavLink
                  ? sibling.classList.toggle('active', true)
                  : sibling.classList.toggle('active', false);
              }
            }

            let filterValue = '';
            // Perform filtering using current tag and parent tag
            // Get parent item tag
            let summary = subNav.closest('.wrapper').previousElementSibling.getElementsByTagName('summary')[0];
            if (summary) {
              filterValue += '.tag--' + summary.dataset.tag;
            }
            filterValue += '.tag--' + subNavLink.dataset.tag;
            filterList(filterValue.trim());
          }

          // ScrollTop documentation list
          Portal.el.appDocList.scrollTop = 0;
        },
        true
      );
    }

    // Filter documentation list by sections
    if (Portal.el.appDocFilters) {
      // Set config variables
      Portal.config.appDocFiltersCount = Portal.el.appDocFilters.querySelectorAll('li').length;
      Portal.config.appDocFiltersActiveCount = Portal.el.appDocFilters.querySelectorAll('li.active').length;

      Portal.el.appDocFilters.addEventListener('click', event => {
        let filter = event.target.closest('li');
        if (!filter) {
          return;
        }
        filter.classList.toggle('active');

        // Get how much filters are active
        Portal.config.appDocFiltersActiveCount = Portal.el.appDocFilters.querySelectorAll('li.active').length;
        //console.log(`Active filters count: ${Portal.config.appDocFiltersActiveCount}`);

        // Get tag from current item
        let filterValue = filter.dataset.filter;

        // Perform filtering by adding d-none--filter class to matching item types in documentation list
        for (const item of Portal.el.appDocListItems) {
          const itemType = item.dataset.itemType.toLowerCase();
          if (itemType === filterValue) {
            item.classList.toggle('d-none--filter');
          }
        }
        // Check documentation list items count and show notification if necessary
        checkAppDocListEmpty();

        // ScrollTop documentation list
        Portal.el.appDocList.scrollTop = 0;
      });

      const btnFiltersReset = Portal.el.appDocListEmptyReset.getElementsByTagName('button')[0];
      if (typeof btnFiltersReset !== 'undefined') {
        btnFiltersReset.addEventListener('click', event => {
          let filters = Portal.el.appDocFilters.querySelectorAll('li:not(.active');
          for (const filter of filters) {
            //filter.click();
            filter.classList.add('active');
          }
          // Reset documentation list items active count
          Portal.config.appDocFiltersActiveCount = Portal.el.appDocFilters.querySelectorAll('li.active').length;
          // Reset documentation list items visibility
          filterList('reset-keep-search');
          // Trigger keyup event to update search results
          Portal.el.appDocSearchInput.dispatchEvent(new KeyboardEvent('keyup', { key: 'Enter' }));
        });
      }
    }

    // Button to show only updated items
    Portal.el.appDocBtnFilterItemsUpdated?.addEventListener('click', event => {
      // Get button, the button text element (span) if exists or button itself if span is not present
      let btn = event.currentTarget,
          btnText = btn.getElementsByTagName('span')[0] ?? btn;
      if (btn.dataset.state === 'inactive' || btn.dataset.state === '' || typeof btn.dataset.state === 'undefined') {
        // Reset subNav menu state to get a full visible list and avoid confusion for the user after filter application
        resetSubNavState();
        // Filter document list to show only updated items by adding a custom class with display none to non matching items
        filterList('updated');
        // Update button text and state
        btnText.innerText = btn.dataset.textHide ?? 'Hide';
        btn.classList.add('active', 'btn-secondary');
        btn.dataset.state = 'active';
      } else {
        // Filter document list to show all items by removing the custom class with display none
        filterList('reset-updated');
        // Update button text and state
        btnText.innerText = btn.dataset.textShow ?? 'Show';
        btn.classList.remove('active');
        btn.dataset.state = 'inactive';
      }
      // Check documentation list items count and show notification if necessary
      checkAppDocListEmpty();
    });

    // Search documentation from user text input
    if (Portal.el.appDocSearchInput) {
      // Search input FOCUS event listener
      Portal.el.appDocSearchInput.addEventListener('focus', event => {
        // Reset subNav menu state to get a full visible list and avoid confusion for the user after filter application
        resetSubNavState();
      });

      if (Portal.el.appDocListItems) {
        // Sort documentation list by name ASC
        //sortDocumentationList()
        const searchKeys = [];
        // Iterate all items to perform filtering by adding bootstrap class "d-none"
        for (const [index, item] of [...Portal.el.appDocListItems].entries()) {
          // Get text elements
          let itemName = item.getElementsByClassName('app-doc__item-name')[0],
            //itemDesc = item.getElementsByClassName('app-doc__item-desc')[0],
            itemSigla = item.getElementsByClassName('app-doc__item-sigla')[0],
            itemCommName = item.getElementsByClassName('app-doc__item-commName')[0];
          // Item data object
          let itemObject = {};
          // Set item index reference
          itemObject.refIndex = index;
          // Check for dom elments and use their texts to populate search data object
          // NAME
          if (typeof itemName !== 'undefined') {
            itemObject.name = itemName.textContent.replace(/\s{2,}/g, ' ').trim();
            !searchKeys.includes('name') ? searchKeys.push('name') : null;
          }
          /*// DESCRIPTION
          if (typeof itemDesc !== 'undefined') {
            itemObject.desc = itemDesc.textContent.replace(/\s{2,}/g, ' ').trim();
            searchKeys.includes('desc') ? searchKeys.push('desc') : null;
          }*/
          // SIGLA
          if (typeof itemSigla !== 'undefined') {
            itemObject.sigla = itemSigla.textContent.replace(/\s{2,}/g, ' ').trim();
            !searchKeys.includes('sigla') ? searchKeys.push('sigla') : null;
          }
          // COMMERCIAL NAME
          if (typeof itemCommName !== 'undefined') {
            itemObject.commName = itemCommName.textContent.replace(/\s{2,}/g, ' ').trim();
            !searchKeys.includes('commName') ? searchKeys.push('commName') : null;
          }
          // ITEM TYPE
          if (typeof item.dataset.itemType !== 'undefined') {
            itemObject.itemType = item.dataset.itemType;
            !searchKeys.includes('itemType') ? searchKeys.push('itemType') : null;
          }
          // Create list json object and push current item data
          Portal.data.appDocListItems.push(itemObject);
        }
        // Search input KEYUP event listener
        Portal.el.appDocSearchInput.addEventListener('keyup', event => {
          // Get current input value
          const searchValue = event.currentTarget.value; /*.toLowerCase()*/
          //console.log(searchValue);
          //console.log(searchKeys)
          if (searchValue !== '') {
            // Search with fuzzysort lib
            Portal.data.searchResults = fuzzysort.go(searchValue, Portal.data.appDocListItems, {
              //limit: 100,    // don't return more results than you need!
              threshold: 0.5, // don't return bad results
              keys: searchKeys
            });
            //console.log(`Whole list search results: ${Portal.data.searchResults.length}`);
            //console.log(Portal.data.searchResults);

            // Iterate all documentation list items and hide them
            for (const item of Portal.el.appDocListItems) {
              item.classList.toggle('d-none', true);
            }

            // Iterate searchResults and remove "d-none" class in Portal.el.appDocListItems
            for (const item of Portal.data.searchResults) {
              Portal.el.appDocListItems[item.obj.refIndex]?.classList.toggle('d-none', false);
            }

            // ScrollTop documentation list
            Portal.el.appDocList.scrollTop = 0;

            // Check documentation list items count and show notification if necessary
            checkAppDocListEmpty();
          } else {
            // Iterate all list items and hide them
            for (const item of Portal.el.appDocListItems) {
              item.classList.toggle('d-none', false);
            }
          }
        });
      }
    }

    // Listen to click event on document list and perform relevant actions
    Portal.el.appDocList.addEventListener('click', event => {
      // Get the closest button from the event bubbling
      let item = event.target.closest('.app-doc__item'),
        el = event.target;

      // Check clicked element type (button | download anchor)
      if (typeof el.dataset.type === 'undefined') {
        el = event.target.closest('button');
        if (el === null) {
          el = event.target.closest('a');
        }
      }

      if (el) {
        // OPEN PDF MODAL VIEWER
        if (el.dataset.type === 'pdf') {
          //console.log('PDF preview');
          let title = item.getElementsByClassName('app-doc__item-name');
          title = title.length > 0 ? title[0].innerText : '';
          openPdfModal(el, title);
        }

        // DOWNLOAD
        if (el.dataset.type === 'download') {
          //console.log('File download');
          /*let src = el.dataset.src;
          if (src) open(src);*/
        }

        // PLAY VIDEO
        if (el.dataset.type === 'video') {
          //console.log('Video preview');
          Fancybox.show(
            [
              {
                //src: `${Portal.config.assetsPath}video/${el.dataset.src}`,
                src: `${el.dataset.src}`,
                caption: el.dataset.caption,
                width: '80%',
                height: '80%'
              }
            ],
            Portal.config.fancyboxVideoOptions
          );
        }

        return; // Return to avoid following code execution
      }

      // If list item is the event target open its file preview by triggering click action
      if (item) {
        let itemType = item.dataset.itemType;
        if (typeof itemType !== 'undefined') {
          el = item.getElementsByClassName('app-doc__item-view')[0];
          if (typeof el !== 'undefined') {
            //console.log('Row clicked');
            el.click();
          }
        }
      }

      if (Portal.el.appDocBtnDownload) {
        // SELECT A CHECKBOX (increment or decrement the download selected counter)
        if (event.target.classList.contains('app-doc__item-input')) {
          let checkBox = event.target;
          if (checkBox.checked) {
            Portal.config.downloadSelection++;
          } else {
            Portal.config.downloadSelection--;
          }
          Portal.config.downloadSelection <= 1
            ? Portal.el.appDocBtnDownload.setAttribute('disabled', true)
            : Portal.el.appDocBtnDownload.removeAttribute('disabled');
        }
      }
    });

    // Download selected docs when clicking the dedicated button
    if (Portal.el.appDocBtnDownload) {
      Portal.el.appDocBtnDownload.addEventListener('click', event => {
        // At least two selection
        if (Portal.config.downloadSelection > 1) {
          alert('download.zip');
          let list = Portal.el.appDocList.querySelectorAll('.form-check-input:checked');
          // Remove checkbox selection after download
          for (const checkbox of list) {
            checkbox.checked = false;
            Portal.el.appDocBtnDownload.setAttribute('disabled', true);
          }
        }
      });
    }
  } // end Portal.el.appDoc

  // PORTAL DASHBOARD
  if (Portal.el.dashboard) {
    Portal.el.dashboard.addEventListener('click', event => {
      let el;

      if (event.target.tagName.toLowerCase() === 'button') {
        el = event.target;
      } else {
        el = event.target.closest('button');
      }

      if (el !== null) {
        // DOWNLOAD PDF OR OPEN URL IN A NEW WINDOW
        if (el.dataset.type === 'download' || el.dataset.type === 'link') {
          let src = el.dataset.src;
          if (src) open(src);
          //console.warn(el);
        }

        // DOWNLOAD PDF OR OPEN URL IN SAME WINDOW
        if (el.dataset.type === 'link-self') {
          let src = el.dataset.src;
          if (src) open(src, '_self');
        }

        // VIEW PRESENTATION
        if (el.dataset.type === 'presentation') {
          openPresentation(el);
        }

        // OPEN PDF MODAL VIEWER
        if (el.dataset.type === 'pdf') {
          openPdfModal(el);
        }
      }
    });
  }

  // Listen to "hide.bs.modal" event on pdfViewer modal
  jQuery(Portal.el.pdfViewer).on('hide.bs.modal', function () {
    // Fix aria-hidden error from the modal keeping focus when it's closed
    if (document.activeElement) {
      document.activeElement.blur();
    }
    // Unload current pdf and remove url from download button
    if (Portal.el.pdfViewer.getElementsByClassName('modal-body')[0].classList.contains('pdfobject-container')) {
      Portal.el.pdfViewer.getElementsByClassName('modal-body')[0].innerHTML = '';
      let btnViewerDownload = Portal.el.pdfViewer.getElementsByClassName('btn-viewer-download')[0];
      if (btnViewerDownload) {
        btnViewerDownload.dataset.src = '';
      }
    }
  });
});

/**
 * Utility function to initialize PerfectScrollbar
 * @param {object} element - target element node
 * @param {object} options - PerfectScrollbar setup options
 */
const initPerfectScrollbar = (element, options = { wheelPropagation: false, suppressScrollX: true }) => {
  if (element) new PerfectScrollbar(element, options);
};

/**
 * Utility function to sort an html list by name (ASC) but considering the user locale
 */
window.sortDocumentationList = () => {
  let list = Portal.el.appDocList.getElementsByTagName('ul')[0];
  let orderedLIs = [...list.children].sort((a, b) =>
    a
      .getElementsByClassName('app-doc__item-name')[0]
      .textContent.localeCompare(b.getElementsByClassName('app-doc__item-name')[0].textContent)
  );
  list.innerHTML = orderedLIs.map(li => li.outerHTML).join('');
};

/**
 * Utility function to check documentation list items visibility
 */
function checkAppDocListEmpty() {
  // Check if all items are hidden
  let counter = 0;
  for (const item of Portal.el.appDocListItems) {
    if (item.classList.contains('d-none') || item.classList.contains('d-none--filter') || item.classList.contains('d-none--not-updated')) {
      counter++;
    }
  }
  // If documentation list is empty show a notification
  counter === Portal.el.appDocListItems.length
    ? Portal.el.appDocListEmpty.classList.toggle('d-none', false)
    : Portal.el.appDocListEmpty.classList.toggle('d-none', true);

  // Set documentation list visible items count
  Portal.config.appDocVisibleItemsCount = Portal.el.appDocListItems.length - counter;
  //console.log(`Visible items: ${Portal.config.appDocVisibleItemsCount}`);

  // If search results are 0 and we have filter menu (documentation search page)
  if (Portal.el.appDocFilters) {
    // If AT LEAST one filter is not active and visible results are 0, show a notification to invite user to reset filters
    if (
      Portal.config.appDocFiltersActiveCount < Portal.config.appDocFiltersCount &&
      Portal.config.appDocVisibleItemsCount === 0
    ) {
      Portal.el.appDocListEmptyReset.classList.toggle('d-none', false);
    } else {
      Portal.el.appDocListEmptyReset.classList.toggle('d-none', true);
    }
  }
}

/*
 * Utility function to reset subNav menu in documentation-list by closing all open details elements in the sidebar menu
 * This is useful to reset the menu state after filtering documentation list to get a full visible list and avoid confusion for the user
 */
function resetSubNavState() {
  // Reset subNav menu selection to get a full visible list
  let subNavDetails = Portal.el.appDocMenu?.getElementsByTagName('details');
  if (subNavDetails) {
    for (const subNavDetail of subNavDetails) {
      // Close subNav
      if (subNavDetail.hasAttribute('open')) subNavDetail.getElementsByTagName('summary')[0].click();
    }
  }
}

/**
 * Filter documentation list based on specified tag
 * @param {object} el - element node to search for setup properties
 */
function filterList(tag) {
  if (typeof tag !== 'undefined') {
    //console.warn(`Filtering list by tag: ${tag}`);

    // Iterate all items to perform filtering by toggling
    let counter = 0;
    for (const item of Portal.el.appDocListItems) {
      switch (tag) {
        case 'reset':
          // Reset all filters by removing custom classes with display none
          item.classList.remove('d-none', 'd-none--filter', 'd-none--not-updated');
          // Reset search input value
          Portal.el.appDocSearchInput.value = '';
          // Reset updated items button state to inactive
          Portal.el.appDocBtnFilterItemsUpdated?.dataset.state === 'active' ? Portal.el.appDocBtnFilterItemsUpdated.click() : null;
          break;
        case 'reset-keep-search':
          item.classList.remove('d-none--filter');
          break;
        case 'updated':
          if (item.matches(`.item-updated`)) {
            item.classList.remove('d-none--not-updated');
          } else {
            item.classList.add('d-none--not-updated');
            counter++;
          }
          break;
        case 'reset-updated':
          item.classList.remove('d-none--not-updated');
          break;
        default:
          if (item.matches(`${tag}`)) {
            item.classList.remove('d-none--filter');
          } else {
            item.classList.add('d-none--filter');
            counter++;
          }
      }
    }
    //console.log(`${counter} - ${Portal.el.appDocListItems.length}`);
    // If the documentation list is empty show a notification
    counter === Portal.el.appDocListItems.length
      ? Portal.el.appDocListEmpty.classList.toggle('d-none', false)
      : Portal.el.appDocListEmpty.classList.toggle('d-none', true);
  }
}

/**
 * Open a presentation using Fancybox as an image gallery
 * @param {object} el - element node to search for setup properties
 */
function openPresentation(el) {
  if (el.dataset.target) {
    let gal = document.querySelector(el.dataset.target);
    const gal_slides_tot = gal.dataset.slides;
    const gal_images = [];
    for (let i = 1; i <= gal_slides_tot; i++) {
      i < 10 ? (i = `0` + i) : i;
      let src = `${gal.dataset.path}${i}.jpg`;
      //console.log(src);
      gal_images.push({ src: src });
    }
    Fancybox.show(gal_images, {
      mainClass: 'mor-fancybox--presentation',
      caption: el.dataset.title,
      //commonCaption: true,
      Images: {
        protected: true
      },
      on: {
        '*': (fancybox, eventName) => {
          switch (eventName) {
            case 'close':
              // Unblur Fancybox to avoid aria-errors
              if (document.activeElement) {
                document.activeElement.blur();
              }
              break;
          }
        }
      }
    });
  }
}

$('body').on('click', '.pdf-modal-view', function (e) {
  openPdfModal(this);
});

/**
 * Open pdf modal to show content
 * @param {object} el - element node to search for setup properties
 */
function openPdfModal(el, title) {
  let pdfOptions = {
    pdfOpenParams: {
      view: 'Fit',
      scrollbar: 0,
      toolbar: 0,
      statusbar: 0,
      messages: 0,
      navpanes: 0
      //page: 2,
    }
  };
  // Change modal title
  let modalTitle = Portal.el.pdfViewer.getElementsByClassName('modal-title')[0];
  title ?? el.dataset.title ?? '';
  if (title !== '') {
    modalTitle.classList.remove('d-none');
    modalTitle.textContent = el.dataset.title;
  } else {
    modalTitle.classList.add('d-none');
    modalTitle.textContent = '';
  }

  // Set pdf url to download button
  let btnViewerDownload = Portal.el.pdfViewer.getElementsByClassName('btn-viewer-download')[0];
  if (btnViewerDownload) {
    btnViewerDownload.dataset.src = `${el.dataset.src}`;
  }

  $('.pdf_viewer_source_src').attr('src', el.dataset.src);
}

/**
 * Get specified element siblings, optionally filtering results by className
 * @param {object} node - element node to find siblings
 * @param {string} className - className to filter
 */
const getSiblings = function (node, className) {
  return [...node.parentNode.children].filter(c =>
    className ? c !== node && c.classList.contains(className) : c !== node
  );
};

/**
 * Get specified element siblings, optionally filtering results by tagName
 * @param {object} node - element node to find siblings
 * @param {string} tagName - tagName to filter
 */
const getSiblingsTag = function (node, tagName) {
  return [...node.parentNode.children].filter(c =>
    tagName ? c !== node && c.tagName.toLowerCase() === tagName : c !== node
  );
};
